<div>
  <ng-container *ngIf="dataSource && dataSource.data.length > 0; else noShare">
    <div class="share-toolbar">
      <mat-form-field>
        <mat-icon matPrefix color="primary">search</mat-icon>
        <input
          matInput
          (keyup)="applyFilter($event.target.value)"
          placeholder="Rechercher"
        />
      </mat-form-field>
      <div class="btn-share" *ngIf="showAddButton">
        <button
          mat-mini-fab
          appTooltip="Ajouter un partage"
          [matMenuTriggerFor]="menuProp"
          color="primary"
        >
          <mat-icon>share</mat-icon>
        </button>
      </div>
      <div *ngIf="showIncreaseViewTooltip" class="increase-view">
        <div>
          Améliorez votre taux de consultation
          <a
            class="info-icon"
            (click)="showIncreaseViewDoc()"
            appTooltip="Plus d'informations"
          >
            <mat-icon class="align-top" aria-label="Plus d'informations"
              >info_outline</mat-icon
            >
          </a>
        </div>
      </div>
    </div>

    <mat-menu #menuProp="matMenu">
      <div
        *ngFor="let prop of ownedProperties"
        [appTooltip]="
          !prop.certified
            ? 'Seuls les biens certifiés peuvent être partagés'
            : ''
        "
      >
        <button
          [disabled]="!prop.certified"
          mat-menu-item
          (click)="addShare(prop)"
        >
          {{ prop.name }}
        </button>
      </div>
    </mat-menu>

    <div>
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="propertyName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Bien</th>
          <td mat-cell *matCellDef="let row" class="main">
            {{ row.propertyName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="propertyOwnerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Propriétaire
          </th>
          <td mat-cell *matCellDef="let row">{{ row.propertyOwner }}</td>
        </ng-container>
        <ng-container matColumnDef="sharedByUser">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Partagé par</th>
          <td mat-cell *matCellDef="let row">{{ row.sharedBy }}</td>
        </ng-container>
        <ng-container matColumnDef="targetUserName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Destinataire
          </th>
          <td mat-cell *matCellDef="let row" class="main">
            {{ row.targetUserName }}
            <mat-icon
              *ngIf="row.targetUserDeleted"
              color="warn"
              class="action-icon-no-pointer"
              appTooltip="L'utilisateur a supprimé son compte."
              >person_off</mat-icon
            >
            <mat-icon
              *ngIf="row.notDelivered"
              color="warn"
              class="action-icon"
              (click)="showNotDeliveredInfo(row.share)"
              appTooltip="L'email n'a pas pu être distribué. Veuillez vérifier l'adresse."
              >warning</mat-icon
            >
            <mat-icon
              *ngIf="!row.notDelivered && row.sharedByOtherUser"
              (click)="showSharedByInfo(row.share)"
              class="action-icon"
              color="primary"
              appTooltip="Partagé par {{ row.sharedBy }}"
              >info</mat-icon
            >
          </td>
        </ng-container>
        <ng-container matColumnDef="dateCreate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Créé le</th>
          <td
            mat-cell
            *matCellDef="let row"
            class="mobile-inline mobile-separator"
          >
            {{ row.dateCreate | dateFormat }}
          </td>
        </ng-container>
        <ng-container matColumnDef="scope">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
          <td
            mat-cell
            *matCellDef="let row"
            class="mobile-inline mobile-separator"
          >
            {{ row.scope }}
          </td>
        </ng-container>
        <ng-container matColumnDef="allowedData">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Données</th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex align-items-center">
              {{ row.allowedData }}
              <mat-icon
                *ngIf="row.defaultAllowedData || !row.fullAllowedData"
                class="no-mobile action-icon ml-2"
                color="primary"
                (click)="
                  row.defaultAllowedData
                    ? actionService.showViewDefaultRightInfo()
                    : actionService.showViewSelectedRightInfo(
                        row.allowedDataDetail
                      )
                "
                appTooltip="Voir les données accessibles"
                >info</mat-icon
              >
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration</th>
          <td
            mat-cell
            *matCellDef="let row"
            class="mobile-inline mobile-separator"
          >
            {{ row.expirationDate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="consulted">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Consulté</th>
          <td mat-cell *matCellDef="let row">
            <div class="d-flex">
              <span
                *ngIf="
                  row.consulted && (!row.visitMode || row.visitAcknowledged)
                "
                appTooltip="Le bien a été consulté {{ row.viewCount }} fois"
              >
                <mat-icon color="accent">check_circle_outline</mat-icon>
                {{ row.viewCount }}
              </span>
              <span
                *ngIf="row.consulted && row.visitMode && !row.visitAcknowledged"
                appTooltip="L'utilisateur a tenté d'accéder au bien mais n'a pas validé bon de visite !"
              >
                <mat-icon color="warn">error_outline</mat-icon>
              </span>
              <span
                *ngIf="!row.consulted"
                appTooltip="Le bien n'a jamais été consulté"
              >
                <mat-icon color="primary">highlight_off</mat-icon>
              </span>
              <button
                *ngIf="row.hasFeedback"
                mat-icon-button
                (click)="viewFeedback(row.share.uid)"
                appTooltip="Voir le rapport de visite"
              >
                <mat-icon color="primary">playlist_play</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="mobile-double-actions">
            <button
              class="mobile-inline"
              mat-icon-button
              [style]="
                modeMyShares && row.share.consulted ? '' : 'visibility: hidden'
              "
              (click)="viewStats(row.share)"
              appTooltip="Voir les vues"
            >
              <mat-icon color="primary">bar_chart</mat-icon>
            </button>
            <button
              *ngIf="canUpdateShares"
              mat-icon-button
              [matMenuTriggerFor]="actions"
              [matMenuTriggerData]="{ data: row }"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        [pageSize]="paging.pagingPageSize"
        [pageSizeOptions]="paging.pagingPageSizeOptions"
        showFirstLastButtons
      ></mat-paginator>
    </div>
  </ng-container>
  <ng-template #noShare>
    <span class="no-content">Aucun partage n'est disponible</span>
  </ng-template>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li *ngIf="modeMyShares && row.share.endDate && !row.targetUserDeleted">
        <button
          mat-menu-item
          [matMenuTriggerFor]="menuExtend"
          [matMenuTriggerData]="{ data: row }"
        >
          <mat-icon color="primary">add</mat-icon>Étendre la durée
        </button>
      </li>
      <li *ngIf="modeMyShares && !row.targetUserDeleted">
        <button mat-menu-item (click)="edit(row.share)">
          <mat-icon color="primary">create</mat-icon>Modifier le partage
        </button>
      </li>
      <li *ngIf="modeMyShares && row.canResendNotification">
        <button mat-menu-item (click)="confirmResendNotification(row.share)">
          <mat-icon color="primary">send</mat-icon>Renvoyer la notification
        </button>
      </li>
      <li *ngIf="modeMyShares && row.canAddFeedback">
        <button mat-menu-item (click)="addFeedback(row.share)">
          <mat-icon color="primary">playlist_add_check</mat-icon>Saisir le
          rapport de visite
        </button>
      </li>
      <li *ngIf="modeMyShares && row.canAskFeedback">
        <button mat-menu-item (click)="confirmAskFeedback(row.share)">
          <mat-icon color="primary">playlist_add</mat-icon>Envoyer le rapport de
          visite
        </button>
      </li>
      <li *ngIf="modeMyShares && row.hasFeedback">
        <button mat-menu-item (click)="viewFeedback(row.share.uid)">
          <mat-icon color="primary">playlist_play</mat-icon>Voir le rapport de
          visite
        </button>
      </li>
      <li *ngIf="modeMyShares && row.canDeleteFeedback">
        <button mat-menu-item (click)="confirmDeleteFeedback(row.share)">
          <mat-icon color="primary">playlist_remove</mat-icon>Supprimer le
          rapport de visite
        </button>
      </li>
      <li>
        <button
          mat-menu-item
          *ngIf="!(authenticationService.guestMode | async)"
          (click)="confirmDelete(row.share)"
        >
          <mat-icon color="primary">delete_forever</mat-icon>Supprimer le
          partage
        </button>
      </li>
    </ul>
  </ng-template>
</mat-menu>

<mat-menu #menuExtend="matMenu">
  <ng-template matMenuContent let-row="data">
    <button
      *ngFor="let duration of sharingDurations"
      mat-menu-item
      (click)="extendDuration(row.share, duration)"
    >
      {{ sharingDurationNames[duration] }}
    </button>
  </ng-template>
</mat-menu>
